import {
  Box,
  // Button,
  VStack,
} from "@chakra-ui/react";
import { HStack } from "goi_common";

function FacilityInformationSection({ care }: { care: any }) {
  return (
    <>
      <Box padding="32px 20px">
        <table style={{ width: "100%" }}>
          <VStack as="tbody" style={{ gap: "8px" }} alignItems="start">
            <TableRow title="기관종류" description={care.type} />
            <TableRow title="지정일자" description={care.date} />
            <TableRow title="주소" description={care.address} />
            <TableRow title="입소 정원" description={care.total_people} />
            <TableRow title="현재 입원 수" description={care.now_people} />
          </VStack>
          <Box as="p" className="caption_12_m gray700">
            (24년 7월 기준)
          </Box>
        </table>

        {/* <Button
          className="button_16_sb"
          style={{
            color: "white",
            background: colors.black,
            width: "100%",
            height: "50px",
            borderRadius: "5px",
            margin: "30px 0px 30px 0px",
          }}
          onClick={() => {
            customEvent({
              newGtm: {
                path: "hospice_detail",
                trigger_and_target: "CTA_call",
              },
            });
            call("1666-9784");
          }}
        >
          호스피스 문의하기
        </Button> */}
      </Box>
    </>
  );
}

export default FacilityInformationSection;

const TableRow = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <HStack as="tr">
      <Box as="td" className="body3_r gray700" minWidth="105px">
        {title}
      </Box>
      <Box as="td" className="body3_m gray900" wordBreak="keep-all">
        {description ? description : "-"}
      </Box>
    </HStack>
  );
};
